module.exports = function() {
    return {
        id: null,
        title: "",
        description: ""
    }
}